'use client';

import { cn } from '@workspace/ui/lib';
import type { ReactNode } from 'react';

interface AppTopHeaderProps {
  left?: ReactNode;
  organisationSwitcher?: ReactNode;
  notifications?: ReactNode;
  profileMenu?: ReactNode;
  className?: string;
}

export function AppTopHeader({
  left,
  organisationSwitcher,
  notifications,
  profileMenu,
  className,
}: AppTopHeaderProps) {
  return (
    <div className={cn('flex min-h-[30px] w-full items-center justify-between gap-4', className)}>
      <div className="flex min-w-0 flex-1 items-center gap-3">{left}</div>

      <div className="flex shrink-0 items-center gap-3">
        {organisationSwitcher}
        {notifications}
        {profileMenu}
      </div>
    </div>
  );
}
